import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import useAxios from '../../../hooks/useAxios';
import {
  IGetSpeakingRubric,
  IPostSpeakingRubricReq,
} from '../../../models/newSpeaking.model';
import { postSpeakingRubric } from '../../../api/newSpeaking.api';
import SpeakingRubricEditor from '../../../components/cbt/speaking-rubric/SpeakingRubricEditor';
import useNotification from '../../../hooks/useNotification';
import { useHistory } from 'react-router-dom';
import ErrorResponse from '../../../components/ErrorResponse';
import Loader from '../../../components/Loader';

const CbtSpeakingRubricCreate: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios<IGetSpeakingRubric>();

  useEffect(() => {
    if (submitRes) {
      successNotification(t('common.message.save1'));
      history.push('/cbt/speaking-rubric');
    }
  }, [submitRes]);

  const submit = (req: IPostSpeakingRubricReq) => {
    submitExecute(postSpeakingRubric(req));
  };

  return (
    <div className="content scrollbar">
      {submitIsLoading && <Loader />}
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-cbt-big.svg"
        parentMenu={t('common.menu.cbt')}
        currentMenu={t('cbt.speakingRubric.11')}
      />
      <SpeakingRubricEditor
        submit={submit}
      />
    </div>
  );
};

export default CbtSpeakingRubricCreate;
